import { render } from "./TextMultiComponent.vue?vue&type=template&id=5abce38d&ts=true"
import script from "./TextMultiComponent.vue?vue&type=script&lang=ts"
export * from "./TextMultiComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/SurveyPublic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__